
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Box from 'vux/src/components/box/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import cookie from 'vux/src/tools/cookie/index.js'


export default{
data () {
return {
contents: [
{
'title': '支付宝',
'img': '../../static/images/guide/alipay/1.png',
'subtitle': '请截图或点击保存二维码'
},
{
'title': '支付宝',
'img': '../../static/images/guide/alipay/2.png',
'subtitle': '使用本机或其他手机<br />扫描二维码支付提示金额'
},
{
'title': '支付宝',
'img': '../../static/images/guide/alipay/3.png',
'subtitle': '请务必在规定时间内完成支付'
},
{
'title': '支付宝',
'img': '../../static/images/guide/alipay/4.png',
'subtitle': '<span style="color: #E02020">*切勿转账给在线客服<br />*如转账中遇到风险提示，请参照以下措施</span><br />一、请点击关闭或取消继续付款<br />二、重新发起充值订单<br />三、更换付款账号进行付款'
},
{
'title': '支付宝',
'img': '../../static/images/guide/alipay/5.png',
'subtitle': '切勿重复扫码支付，以免造成资金损失'
},
{
'title': '支付宝',
'img': '../../static/images/guide/alipay/6.png',
'subtitle': '如充值不到账，<br />请点击“我”中的“积分”进入收银台<br />再点击“在线客服”'
},
{
'title': '支付宝',
'img': '../../static/images/guide/alipay/7.png',
'subtitle': '请提供游戏ID及充值截图给客服查询'
}
],
play: false,
loaded: false
}
},
components: {
Swiper,
SwiperItem,
Loading,
Group,
Cell,
ViewBox,
XHeader,
XButton,
Box,
XInput,
PopupRadio,
Popup,
Radio,
cookie
},
mounted () {
this.loaded = true
this.play = true
},
methods: {
}
}



// WEBPACK FOOTER //
// ./src/components/Alipay.vue